import { render } from "./SeatSummery.vue?vue&type=template&id=27c12bc1"
import script from "./SeatSummery.vue?vue&type=script&lang=js"
export * from "./SeatSummery.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__